var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPostAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 22.4233H5.83333V8.16667H14V5.83334H5.83333C4.55 5.83334 3.5 6.88334 3.5 8.16667V22.1667C3.5 23.45 4.55 24.5 5.83333 24.5H19.8333C21.1167 24.5 22.1667 23.45 22.1667 22.1667V14H19.8333V22.4233Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.5H8.16666V12.8333H17.5V10.5Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16666 14V16.3333H17.5V14H14H8.16666Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5H8.16666V19.8333H17.5V17.5Z",
    fill: "current"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostAdd);
export default __webpack_public_path__ + "static/media/post_add.4afa2f1b.svg";
export { ForwardRef as ReactComponent };